// Email, phone, website and US address rules, matching api/app/common/contact.py. contact.cases.json is tested against
// both, so they can't drift apart. The API has the final say.

const EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
const PHONE_CHARACTERS = /^\+?[\d\s().-]+$/;

const STATE = /^[A-Za-z]{2}$/;
const POSTAL_CODE = /^\d{5}(-\d{4})?$/;
const WEBSITE = /^https?:\/\/[^\s/.]+(\.[^\s/.]+)+(\/\S*)?$/i;

export const INVALID_STATE = 'Enter the state as two letters, like GA';
export const INVALID_POSTAL_CODE = 'Enter a ZIP code, like 30301';
export const INVALID_WEBSITE = 'Enter a website address, like example.com';
export const INVALID_EMAIL = 'Enter a valid email address';
export const INVALID_PHONE = 'Enter a phone number with its area code, like (404) 555-0123';

export function isValidEmail(value: string): boolean {
  return EMAIL.test(value.trim().toLowerCase());
}

export function isValidPhone(value: string): boolean {
  const phone = value.trim();
  if (!PHONE_CHARACTERS.test(phone)) return false;
  const digits = phone.replace(/\D/g, '');
  if (phone.startsWith('+')) return digits.length >= 8 && digits.length <= 15;
  return digits.length === 10 || (digits.length === 11 && digits.startsWith('1'));
}

export function isValidState(value: string): boolean {
  return STATE.test(value.trim());
}

export function isValidPostalCode(value: string): boolean {
  return POSTAL_CODE.test(value.trim());
}

export function isValidWebsite(value: string): boolean {
  const website = value.trim();
  return WEBSITE.test(website.includes('://') ? website : `https://${website}`);
}

/** How a stored number looks on screen. Anything that isn't a US number shows as stored. */
export function formatPhone(value: string | null | undefined): string {
  if (!value) return '';
  const us = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(value);
  return us ? `(${us[1]}) ${us[2]}-${us[3]}` : value;
}
